import "./MeshAndFiltrationFundamentals.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import HeroFundamentals from "./sections/HeroFundamentals";
import TechnicalReferenceGrid from "./sections/TechnicalReferenceGrid";
import RelatedArticles from "./sections/RelatedArticles";
import CustomMeshQuoteCTA from "./sections/CustomMeshQuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function MeshAndFiltrationFundamentalsPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="MeshAndFiltrationFundamentals" />
      <HeroFundamentals />
      <TechnicalReferenceGrid />
      <RelatedArticles />
      <CustomMeshQuoteCTA />
      <Footer />
    </div>;
}